import backbtn from '../../../assets/images/Dashboard/back-btn.svg'
import { Button, Col, Dropdown, Row } from 'react-bootstrap';
import dashboardLibrary from '../../../assets/images/Sidebar/dashboardLibrary.svg'
import saveCustomView from '../../../assets/images/Sidebar/saveCustomView.svg'
import chevronDown from '../../../assets/images/Sidebar/chevron-down-white.svg'
import { useState } from 'react';
import SaveCustomeViewModal from '../../ContentSection/DashBoard/SaveCustomeViewModal';

const Download = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const pdfRef = useRef(null);
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    // Logic to determine if the Analytics button should be visible
    const showAnalytics = props.SignInType !== 'User';

    return (
        <Row className='download-btn-container m-0'>
            <Col md={5} className='backbtn-div'>
                <div className='back-navigation-div' onClick={props.onBackClick}>
                    {props.showBackButton && (
                        <img src={backbtn} alt="Back Button" />
                    )}&nbsp;&nbsp;
                    <span>{props.moduleName}</span>
                </div>
            </Col>
            <Col md={7} className='p-0 download-header-btns'>
                <div className='header-btns'>
                    {props.showDashboardLibraryButton && (
                        <Button onClick={props.onClick}>
                            Dashboard Library
                            &nbsp;&nbsp;<img src={dashboardLibrary} alt="" />
                        </Button>
                    )}

                    {/* Conditionally render the Save Custom View button */}
                    {props.showSaveCustomViewButton && (
                        <Button onClick={handleOpenModal}>
                            Save Custom View
                            &nbsp;&nbsp;<img src={saveCustomView} alt="" />
                        </Button>
                    )}
                    {/* {props.showAnalyticsButton && (
                        <Button onClick={props.onClick}>
                            Analytics
                            &nbsp;&nbsp;<img src={saveCustomView} alt="" />
                        </Button>
                    )} */}
                    {showAnalytics && props.showAnalyticsButton && (
                        <Button onClick={props.onClick}>
                            Analytics &nbsp;&nbsp;<img src={saveCustomView} alt="" />
                        </Button>
                    )}
                    {props.showDownloadDropdown && (
                        <Dropdown>
                            <Dropdown.Toggle as={Button} variant="light" className="download-btn">
                                Download
                                &nbsp;&nbsp;<img src={chevronDown} alt="Chevron Down" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className='download-dropdown-Options'>
                                <Dropdown.Item onClick={props.onImageClick}>Images</Dropdown.Item>
                                <Dropdown.Item onClick={props.onPdfDownloadClick}>PDF</Dropdown.Item>
                                <Dropdown.Item onClick={props.onExcelDownloadClick}>Excel</Dropdown.Item>
                                <Dropdown.Item onClick={props.onWordDownloadClick}>Word Document</Dropdown.Item>
                                <Dropdown.Item onClick={props.onPrintClick}>Print</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                </div>
            </Col>
            {
                isModalOpen && <SaveCustomeViewModal
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                />
            }
        </Row>
    );
}

export default Download;